import { useMemo } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { SI_PORTAL_TABS, getVisibleSiPortalTabs } from '../siPortal.definitions';

/** Abas visíveis pra quem está logado — só roles (sem consulta), então não tem estado de
 * carregamento próprio além do `loading` do AuthContext, já tratado pelo RoleBasedRoute. */
export function useSiPortalTabs() {
  const { userHasRole } = useAuth();
  return useMemo(() => getVisibleSiPortalTabs(SI_PORTAL_TABS, { hasRole: userHasRole }), [userHasRole]);
}
